"use client";

import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { ReactNode, useRef } from "react";

/**
 * Provides a single QueryClient instance to the entire app.
 * Only universally-useful defaults are set here; any query can
 * still override them in its own `useQuery` call.
 */
export default function QueryProvider({ children }: { children: ReactNode }) {
  const clientRef = useRef<QueryClient | null>(null);

  if (!clientRef.current) {
    clientRef.current = new QueryClient({
      defaultOptions: {
        queries: {
          /**  Prevent tab-switch loader flashes everywhere   */
          refetchOnWindowFocus: false,
          /**  One retry is usually enough for transient hiccups */
          retry: 1,
        },
      },
    });
  }

  return <QueryClientProvider client={clientRef.current}>{children}</QueryClientProvider>;
}
